// Game version - automatically incremented on each commit
export const GAME_VERSION = '1.0.1';
